<template>
  <div class="hg">
    <div class="flag1">
    </div>
    <div class="htext bu">{{ text }}</div>
    <div class="flag">
      <span v-if="getRegion(text).length === 2"
            :class="['flag-icon', `flag-icon-${getRegion(text)}`]"></span>
      <span v-else :class="['flag-icon']"></span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    text: { type: String, default: 'undefined' }
  },

  methods: {
    getRegion(text) {
      const regions = ['C1', 'C2', 'C3', 'C4', 'C5', 'CS', 'R1', 'R3', 'R4'];
      let txt = text.split('§')[0];
      txt = _.replace(_.replace(_.replace(text, '-', '_'), '-', '_'), '/', '_');
      txt = _.replace(_.replace(_.replace(txt, 'C5_IC', 'C5'), 'C1_CS', 'C1'), 'C1_NE', 'C1');
      txt = _.replace(txt, 'C1_ES_', 'C1_');
      txt = _.replace(_.replace(_.replace(txt, 'Oman', 'OM'), 'Kuwait', 'KW'), 'UK', 'GB');
      txt = _.replace(_.replace(_.replace(txt, 'EM (Bahrain)', 'BH'), 'MYNM (KSA)', 'MM'), 'C4_LA', 'C4');
      txt = _.replace(_.replace(txt, 'AGMC (Dubai)', 'AE'), 'ADM (Abu Dhabi)', 'AE');
      txt = _.replace(txt, 'AFA (Qatar)', 'QA');
      txt = _.replace(txt, 'AKA (Jordan)', 'JO');
      txt = _.replace(txt, 'BHS (Lebanon)', 'LB');
      txt = _.replace(txt, 'Botswana', 'BW');
      txt = _.replace(txt, 'Namibia', 'NA');
      txt = _.replace(txt, 'Swaziland', 'SZ');
      txt = _.replace(txt, 'Moscow', 'RU');
      let candidates = _.remove(_.split(txt, '_'), function(n) { return !_.includes(regions, n); });
      if (candidates.length === 0) {
        return '';
      } else {
        return candidates[0].toLowerCase();
      }
    }
  }
};

</script>

<style scoped>

  .hg {
    display: grid;
    width: 100%;
    line-height: 1rem;
    grid-template-areas: "flag1 htext flag";
    grid-template-columns: 4fr 22fr 4fr;
  }

  .htext {
    padding-top: 2%;
    grid-area: htext;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 10pt;
  }

  .flag {
    grid-area: flag;
    margin-top: 2px;
  }

  .flag1 {
    grid-area: flag1;
    margin: 2px;
  }

  .bu { /* bold upper */
    font-weight: bold;
    text-transform: uppercase;
  }

</style>
